export default __webpack_public_path__ + "static/media/Lacunal Nexus.40bf5de9.jpg";